import {
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog
} from 'mdb-react-ui-kit';

import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ForgotPassword from './ForgotPassword';
import { MiscContext } from '../context/MiscProvider';

const ForgotPasswordModal = ({ toggleForgotPasswordModal,countDown,setCountDown,setIsForgotUserId,  
    setIsForgotPassword,
    
    setCheckingToken,
    toggleLoggedIn}) => {

    
        const { forgotPasswordModalOpen} = useContext(MiscContext);
        

        return (
     
        
        <MDBModal staticBackdrop={true} closeOnEsc={false}
            animationDirection='right'
            open={forgotPasswordModalOpen}
            centered={true}
            onClose={toggleForgotPasswordModal}>
               
            <MDBModalDialog  >
            {/* <MDBAlert open={showAlert}
                    color='warning'
                    autohide ={true}
                    delay={20000}
                    onClose={() => setShowAlert(false)} 
                >
                   
                   <i className='fas fa-check-circle me-3'></i>  {alertMessage}  <MDBBtn className="btn-close ms-2" color='success' onClick={()=> setShowAlert(false)}></MDBBtn>
                </MDBAlert> */}
            <MDBModalContent >
                <MDBModalBody >
                <ForgotPassword 
                    setCheckingToken={setCheckingToken} 
                    toggleLoggedIn={toggleLoggedIn}
                   countDown={countDown}
                   setCountDown={setCountDown}
                   setIsForgotUserId={setIsForgotUserId}  
                    setIsForgotPassword={setIsForgotPassword}
                   
                   />
                </MDBModalBody>

          
                </MDBModalContent>
                
            </MDBModalDialog>
        </MDBModal>
  
    )
};
ForgotPasswordModal.propTypes = {
    toggleForgotPasswordModal: PropTypes.func,
    setTokenLoaded: PropTypes.func,
    setCheckingToken: PropTypes.func,
    toggleLoggedIn: PropTypes.func,
    countDown: PropTypes.number,
    setCountDown: PropTypes.func,
    setIsForgotUserId: PropTypes.func,
    setIsForgotPassword: PropTypes.func,

   
}
export default ForgotPasswordModal;
